const IP_URL = process.env.REACT_APP_NODE_API_URL

export const getLocationsByGroups = async (locations_groups, application_id) => {
  try {
    const response = await fetch(
      IP_URL + "api_locations/get_all_locations_by_group_id",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          locations_groups_list: locations_groups,
        }),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    //console.error("Error al iniciar sesión", error);
    var aux = 0;
  }
};